export default {
  getSpinner: state => state.spinner,
  getReportingDates: state => state.reportingDates,
  getIntercom: state => state.intercom
}
